<template>

  <div class="w-full h-full flex flex-col">
    <Particles
        id="tsparticles"
        :options="{
                    background: {
                        color: {
                            value: '#041729'
                        }
                    },
                    fpsLimit: 120,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: 'push'
                            },
                            onHover: {
                                enable: true,
                                mode: 'repulse'
                            },
                            resize: true
                        },
                        modes: {
                            bubble: {
                                distance: 250,
                                duration: 2,
                                opacity: 0.8,
                                size: 5
                            },
                            push: {
                                quantity: 4
                            },
                            repulse: {
                                distance: 100,
                                duration: 0.4
                            }
                        }
                    },
                    particles: {
                        color: {
                            value: '#ffffff'
                        },
                        links: {
                            color: '#ffffff',
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 1
                        },
                        collisions: {
                            enable: true
                        },
                        move: {
                            direction: 'none',
                            enable: true,
                            outModes: {
                                default: 'out'
                            },
                            random: true,
                            speed: 3,
                            straight: false
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800
                            },
                            value: 80
                        },
                        opacity: {
                            value: 0.5
                        },
                        shape: {
                            type: 'circle'
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        }
                    },
                    detectRetina: true
                }"
        :particlesInit="particlesInit"
        :particlesLoaded="particlesLoaded"/>
    <div class="w-full h-full px-6 h-500p lg:h-800p flex items-center justify-center flex-col relative">
      <div class="text-white font-normal text-18 lg:text-24 z-20" data-aos="fade-down">{{ page.sub_title }}</div>
      <h1 class="text-white font-bold text-32 lg:text-68 uppercase z-20 text-center px-6" data-aos="fade-down">
        <highlighted-text :text="page.title" />
      </h1>

      <div class="
          absolute
          m-auto
          bottom-0
          py-7
          sm:py-11
          px-6 sm:px-12 lg:px-100p
          rounded-45p sm:rounded-100p
          max-w-content
          w-11/12 sm:w-4/6
          flex
          flex-col lg:flex-row
          justify-around lg:justify-between
          items-center
          absolute
          bottom-0
          transform translate-y-50c
          shadow-4xl
          bg-white
          z-20
          "
      >
        <div class="text-20 text-neutral/500 text-center lg:text-left font-bold">
          {{ page.c_sec_text }}
        </div>
        <custom-button class="lg:mt-0 mt-10" @buttonClick="$router.push('contact-us')">
          {{ page.c_sec_button }}
        </custom-button>
      </div>
    </div>


<!--    How we can help your business grow section-->
    <section-layout class="pt-128p xl:pt-96p">
      <template #title>
        How we can help your business grow
      </template>

      <div
        class="
            mx-auto
            flex
            flex-wrap
            justify-center
            gap-4 sm:gap-x-10 lg:gap-x-20  sm:gap-y-6 lg:gap-y-12
            pb-16
            container-md
            px-6"
      >
        <help-your-business-cart
          v-for="(item, index) in helpBusinessData"
          :key="item.id"
          :data-aos-delay="index * 80"
          @click="$router.push(`services#${item.redirectHash}`)"
        >
          <template #icon>
            <img
              v-if="item.imageUrl"
              :src="item.imageUrl"
              :alt="item.title"
              class="w-64p h-62p object-contain"
            />
            <div v-else v-html="item.icon"/>
          </template>

          <template #title>
            {{ item.title }}
          </template>

          <template #description>
            {{ item.description }}
          </template>
        </help-your-business-cart>

        <div class="w-full flex items-center justify-center mt-80p" data-aos="fade-up" data-aos-delay="120">
          <custom-button type="primary" :arrow="true" @buttonClick="$router.push('services')">
            Observe all services
          </custom-button>
        </div>

      </div>

    </section-layout>

<!--    Clients section-->
    <section-layout class="pt-0 md:pt-0">
      <template #title>
        Clients we have worked with
      </template>

      <template #subtitle>
        {{ clients.length }} products we have taken from an idea to a release
      </template>

      <div class="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-12 gap-y-10 sm:gap-x-16">
        <router-link
          v-for="(client, index) in clients"
          :key="client.id"
          :to="`/project-info/${client.id}`"
          class="client-logo flex items-center justify-center h-16 w-36"
          :aria-label="client.brand"
          data-aos="fade-up"
          :data-aos-delay="(index % 5) * 70"
        >
          <img :src="client.logo" :alt="client.brand" class="max-h-12 max-w-full object-contain">
        </router-link>
      </div>

      <div class="w-full flex items-center justify-center mt-16" data-aos="fade-up">
        <custom-button type="secondary" :arrow="true" @buttonClick="$router.push('projects')">
          See our projects
        </custom-button>
      </div>
    </section-layout>

<!--    Our Development process section-->
    <div class="w-full h-800p bg-home-section-2 bg-no-repeat bg-cover flex items-center justify-center flex-col relative gap-12 ">
      <div class="w-full flex items-center justify-center flex flex-col max-w-content mx-auto gap-12">
        <div class="text-24 md:text-32 text-white text-center font-bold" data-aos="fade-up">{{ processTitle }}</div>
        <div class="w-full hidden lg:flex justify-between items-end lg:px-24 xl:px-32 " data-aos="fade-up" data-aos-delay="60">
          <div class="bg-first-step bg-no-repeat w-32 h-32 transform -translate-x-1/2"></div>
          <div class="bg-second-step bg-no-repeat w-32 h-32"/>
          <div class="bg-third-step bg-no-repeat w-32 h-32"/>
          <div class="bg-fourth-step bg-no-repeat w-44 h-24 transform translate-x-1/2"></div>
        </div>

        <div class="w-full lg:px-24 xl:px-32 h-12 hidden lg:flex items-center justify-start" data-aos="fade-up" data-aos-delay="90">
          <div class="bg-process-line bg-no-repeat w-full h-full bg-contain"/>
        </div>
        <div class="process-item-wrapper flex flex-col lg:flex-row justify-between lg:items-center px-6 lg:px-24 xl:px-32">
          <div
            v-for="(step, index) in processSteps"
            :key="step.id"
            class="process-item relative w-full lg:w-3/12 text-white text-20 lg:text-24 font-bold whitespace-normal text-left"
            :class="stepAlignment(index)"
            data-aos="fade-up"
            :data-aos-delay="index * 120"
          >
            {{ step.title }}
          </div>
        </div>
        <div class="w-full flex items-center justify-center mt-24" data-aos="fade-up" data-aos-delay="600">
          <custom-button :arrow="true" @buttonClick="$router.push('/about#workflow')">
            More Details
          </custom-button>
        </div>
      </div>
    </div>


<!--    Why Choose Us section-->
    <section-layout>
      <template #title>
        Why Choose Us
      </template>

      <div class="w-full flex justify-center flex-col lg:flex-row gap-8 lg:gap-10">
        <div class="w-full lg:w-1/2 md:h-500p p-33c md:p-0 bg-contain bg-why-choose-us bg-no-repeat" data-aos="fade-right"/>
        <div class="lg:w-2/6 flex flex-col lg:items-start justify-center gap-4">

          <div
            class="flex justify-start gap-2 items-center"
            v-for="(item, index) in WhyChooseUsData"
            :key="item.id"
            data-aos="fade-up"
            :data-aos-delay="index * 70"
          >
            <div class="w-6 h-6 bg-point bg-no-repeat"></div>
            <div class="text-black text-24 font-normal">
              {{ item.title }}
            </div>
          </div>

          <div class="flex items-center justify-center md:justify-start mt-50p md:mt-6" data-aos="fade-up" data-aos-delay="500">
            <custom-button :arrow="true" @buttonClick="$router.push('about')">
              About us
            </custom-button>
          </div>

        </div>
      </div>

    </section-layout>

<!--    The Team section-->

    <section-layout class="md:pt-0 pb-96p">
      <template #title>
        {{ teamTitle }}
      </template>

      <template #subtitle>
        {{ teamSubtitle }}
      </template>

      <div class="w-full flex flex-col items-center">
        <!-- состав компании меняется, поэтому на главной не перечисляем людей
             поимённо: фото секции загружается в админке, актуальный состав
             живёт на странице «О нас» -->
        <div class="relative w-full max-w-2xl px-6" data-aos="fade-up">
          <img :src="teamImage" :alt="teamImageAlt" class="w-full">
        </div>

        <div class="w-full flex items-center justify-center mt-16" data-aos="fade-up">
          <custom-button :arrow="true" @buttonClick="$router.push('about')">
            More about us
          </custom-button>
        </div>
      </div>

    </section-layout>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
<script setup>

import { loadFull } from 'tsparticles'
import { computed } from 'vue';
import { useContent } from '@/composables/useContent'
import HelpYourBusinessCart from '@/components/Home/HelpYourBusinessCart'
import CustomButton from '@/components/UI_components/CustomButton'
import HighlightedText from '@/components/UI_components/HighlightedText'
import SectionLayout from '@/layouts/SectionLayout'

// Иконки заданы в вёрстке — в админке у карточек редактируется только текст.
const serviceIcons = [
  { icon: `<div class="bg-web-application-development w-64p h-62p bg-no-repeat"></div>`, redirectHash: 'web-application-development-section' },
  { icon: `<div class="bg-testing-qa w-64p h-62p bg-no-repeat"/>`, redirectHash: 'testing-qa-section' },
  { icon: `<div class="bg-mobile w-64p h-62p bg-no-repeat"/>`, redirectHash: 'mobile-section' },
  { icon: `<div class="bg-custom-software w-64p h-62p bg-no-repeat"/>`, redirectHash: 'custom-software-development-section' },
  { icon: `<div class="bg-outsource w-64p h-62p bg-no-repeat"/>`, redirectHash: 'outsource-section' },
]

const defaultServices = [
  {
    id: 1,
    icon: `<div class="bg-web-application-development w-64p h-62p bg-no-repeat"></div>`,
    title: `Web Application Development`,
    description: `Regardless of how complex or even small your needs are, our dedicated in-house team of web developers
                  and project managers will ensure that the job gets done with the highest level of professionalism and most cost affordably.`,
    redirectHash: 'web-application-development-section'
  },
  {
    id: 2,
    icon: `<div class="bg-testing-qa w-64p h-62p bg-no-repeat"/>`,
    title: `Testing and QA`,
    description: `We reimagine QA and end-to-end testing strategies to help you achieve success in digital.`,
    redirectHash: 'testing-qa-section'
  },
  {
    id: 3,
    icon: `<div class="bg-mobile w-64p h-62p bg-no-repeat"/>`,
    title: `Mobile Application Development`,
    description: `We help businesses appear in the Google Play Store and Apple Store with their custom business app.
                  We transform your idea into a powerful online service that conveys trust and respect to the users.`,
    redirectHash: 'mobile-section'
  },
  {
    id: 4,
    icon: `<div class="bg-custom-software w-64p h-62p bg-no-repeat"/>`,
    title: `Custom Software Development`,
    description: `If you have the next software project in mind - we have the cross-functional
                  expertise that’ll help you with tailored custom software development solutions while cutting project costs`,
    redirectHash: 'custom-software-development-section'
  },
  {
    id: 5,
    icon: `<div class="bg-outsource w-64p h-62p bg-no-repeat"/>`,
    title: `Outsourced Product Development`,
    description: `We productize your ideas in a way that helps you stay a cut above the ordinary. We bring together
                  our top talents to design your product, roll it out in the market and enhance it iteratively.`,
    redirectHash: 'outsource-section'
  }
]

const { items: serviceCards } = useContent('homeBusinessGrowCard', defaultServices)

const helpBusinessData = computed(() => serviceCards.value.map((item, index) => ({
  id: item.id ?? index,
  icon: serviceIcons[index % serviceIcons.length].icon,
  // адрес картинки передаём значением, а не куском разметки:
  // строить HTML из данных нельзя, их вставляют через v-html
  imageUrl: item.file?.url || '',
  redirectHash: item.redirectHash ?? serviceIcons[index % serviceIcons.length].redirectHash,
  title: item.title,
  description: item.description,
})))

const defaultReasons = [
      'Quality over Quantity',
      'Strong Relationships',
      'Passion and Commitment',
      'Team over Individuals',
      'Happiness and Flourishing',
      'Partnership'
]

const { items: reasons } = useContent('whoChooseUs', defaultReasons)

const WhyChooseUsData = computed(() => reasons.value.map((item, index) => ({
  id: item.id ?? index,
  title: item.type ?? item.title,
})))

const particlesInit = async (engine) => {
  await loadFull(engine)
}
const particlesLoaded = async (container) => {
  console.log('Particles container loaded', container)
}



// ---------- этапы разработки ----------
const defaultSteps = [
  { id: 1, title: 'First Contact' },
  { id: 2, title: 'Project Discussion and Setup' },
  { id: 3, title: 'Development Phase' },
  { id: 4, title: 'Post-Project Communication' },
]

const { items: workflowSteps } = useContent('homeWorkflowSection', defaultSteps)
const { items: workflowSection } = useContent('homeWorkflow', [{ title: 'Our Development process' }])

// на широком экране этапы разложены по линии: первый прижат влево,
// последний вправо, остальные по центру
const stepAlignment = (index) => {
  if (index === 0) return 'lg:text-left'
  if (index === processSteps.value.length - 1) return 'lg:text-right'

  return 'lg:text-center'
}

const processSteps = computed(() => workflowSteps.value.slice(0, 4))
const processTitle = computed(() => workflowSection.value[0]?.title || 'Our Development process')

// ---------- цифры команды ----------
// логотипы клиентов: сами проекты приходят из админки, картинка берётся
// из загруженной или из набора в вёрстке по slug
const { items: clientProjects } = useContent('project', [])

const clients = computed(() => clientProjects.value
  .map((item) => {
    const slug = item.slug || ''
    let logo = item.file?.url || ''

    if (!logo && slug) {
      try {
        logo = require(`@/assets/projects_logos/${slug}.svg`)
      } catch (e) {
        logo = ''
      }
    }

    return { id: slug, brand: item.name, logo }
  })
  .filter((client) => client.logo))

const { items: teamSection } = useContent('homeTeamSection', [{
  title: 'The Team',
  description: 'Alone we can do so little, together we can do much more!',
}])

// фото команды стоит между двумя парами цифр, поэтому список делится пополам

const teamTitle = computed(() => teamSection.value[0]?.title || 'The Team')

// снимок секции загружается через админку; пока его нет, показываем
// нейтральную иллюстрацию, а не устаревшее фото состава
const defaultTeamImage = require('@/assets/backgrounds/team-default.svg')
const teamImage = computed(() => teamSection.value[0]?.file?.url || defaultTeamImage)
const teamImageAlt = computed(() => teamSection.value[0]?.title || 'Digital Threads team at work')
const teamSubtitle = computed(() => teamSection.value[0]?.description || 'Alone we can do so little, together we can do much more!')


// Заголовок главной и текст блока «обсудим?» редактируются в админке
const defaultPage = {
  title: '*result-driven* software development',
  sub_title: 'Accelerate your business with',
  c_sec_text: 'Are you looking for help with web, mobile or software application development',
  c_sec_button: "Let's discuss!",
}

const { items: pageData } = useContent('homePage', [defaultPage])
const page = computed(() => pageData.value[0] ?? defaultPage)

</script>

<style scoped>
::v-deep(canvas) {
  position: relative !important;
}
.client-logo {
  filter: grayscale(1);
  opacity: .75;
  transition: filter .25s ease, opacity .25s ease, transform .25s ease;
}

.client-logo:hover {
  filter: grayscale(0);
  opacity: 1;
  transform: translateY(-3px);
}

.client-logo:focus-visible {
  outline: 2px solid #E8B300;
  outline-offset: 6px;
  filter: grayscale(0);
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .client-logo {
    transition: none;
  }

  .client-logo:hover {
    transform: none;
  }
}

@media(max-width: 1023px) {
  .process-item-wrapper {
    border-left: 6px solid #a9a9a9;
    margin-left: 72px;
  }
  .process-item-wrapper > .process-item:not(:last-child) {
    padding-bottom: 48px;
  }
  .process-item:before {
    color: #a9a9a9;
    font-size: 44px;
    position: absolute;
    top: -18px;
    left: -100px;
    width: 64px;
    height: 64px;
    text-align: right;
  }
  .process-item:nth-child(1):before {
    content: '01';
  }
  .process-item:nth-child(2):before {
    content: '02';
  }
  .process-item:nth-child(3):before {
    content: '03';
  }
  .process-item:nth-child(4):before {
    content: '04';
  }
  .process-item:after {
    content: '';
    position: absolute;
    display: inline-block;
    width: 24px;
    height: 24px;
    background-color: #a9a9a9;
    top: -2px;
    border-radius: 50%;
    left: -39px;
  }
  .process-item:last-child:after {
    top: 12px;
  }
}
  </style>
